import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import DescriptiveRemainingTimer from "./DescriptiveRemainingTimer";

export default function PostExamUploadHeader({
  candidateName,
  rollNo,
  examName,
  uploadDuration,
  onExpire,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: "#f0f0fb",
        borderBottom: "1px solid #e0e0e0",
        px: { xs: 2, sm: 4 },
        py: { xs: 1.5, sm: 1.5 },
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {isMobile ? (
        // ── Mobile layout ────────────────────────────────────────────────────
        <Box>
          {/* Exam name */}
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              textAlign: "center",
              mb: 1.5,
              lineHeight: 1.3,
              color: "#1e1e1e",
            }}
          >
            {examName}
          </Typography>

          {/* Candidate + Timer row */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            {/* Candidate info */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  lineHeight: 1.3,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {candidateName}
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "gray",
                  lineHeight: 1.3,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                ({rollNo})
              </Typography>
            </Box>

            {/* Timer */}
            <DescriptiveRemainingTimer
                uploadDuration={uploadDuration}
                onExpire={onExpire}
            />
          </Box>
        </Box>
      ) : (
        // ── Desktop layout ───────────────────────────────────────────────────
        // Single row: Candidate (left) | Exam name (center) | Timer (right)
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minHeight: "56px",
            gap: 2,
          }}
        >
          {/* Left: Candidate info */}
          <Box
            sx={{
              flex: "0 0 auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{ fontSize: "14px", fontWeight: "bold", lineHeight: 1.3 }}
            >
              {candidateName}
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "gray", lineHeight: 1.3 }}>
              ({rollNo})
            </Typography>
          </Box>

          {/* Center: Exam name */}
          <Box sx={{ flex: 1, textAlign: "center" }}>
            <Typography
              sx={{
                fontSize: { md: "17px", lg: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                color: "#1e1e1e",
              }}
            >
              {examName}
            </Typography>
          </Box>

          {/* Right: Timer */}
          <Box
            sx={{
              flex: "0 0 auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <DescriptiveRemainingTimer
                uploadDuration={uploadDuration}
                onExpire={onExpire}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
